import React, { useState } from "react";
import { Card } from "reactstrap";

import {
  Block,
  BlockBetween,
  BlockTitle,
  Row,
  Col,
  RSelect,
} from "../../Component";
import BlockUpdateButton from "../../button/BlockUpdateButton";
import { LANGUAGES } from "../MultiLanguageInput";
import { useVacancyBlockSave } from "./useVacancyBlockSave";

import {
  VACANCY_TYPES,
  VACANCY_TYPES_READABLE,
} from "../../../utilities/constants";
import { normalizeVacancy } from "../../../utilities/vacancyUtils";

const typeOptions = Object.values(VACANCY_TYPES).map((value) => ({
  value,
  label: VACANCY_TYPES_READABLE[value],
}));

const VacancyBasicInfoBlock = () => {
  const { save, vacancy } = useVacancyBlockSave();

  const [hasEditClicked, setHasEditClicked] = useState(false);
  const [form, setForm] = useState(() => {
    const { jobTitle, vacancyType, orderIndex } = normalizeVacancy(vacancy);
    return { jobTitle, vacancyType, orderIndex };
  });

  const handleOnEditClicked = () => setHasEditClicked((prev) => !prev);

  const handleSubmit = (e) => {
    e.preventDefault();
    save(form, () => setHasEditClicked(false));
  };

  return (
    <Card className="card-inner">
      <Block>
        <form onSubmit={handleSubmit}>
          <BlockBetween>
            <BlockTitle tag="h5">Basic Information</BlockTitle>
            <BlockUpdateButton
              hasEditClicked={hasEditClicked}
              handleOnEditClicked={handleOnEditClicked}
            />
          </BlockBetween>

          {hasEditClicked ? (
            <div className="mt-3">
              <label className="form-label">Job title</label>
              <Row>
                {LANGUAGES.map((language) => (
                  <Col md="4" className="mb-2" key={language.key}>
                    <div className="overline-title text-soft mb-1">
                      {language.short}
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={language.placeholder}
                      value={form.jobTitle?.[language.key] ?? ""}
                      onChange={(e) =>
                        setForm((prev) => ({
                          ...prev,
                          jobTitle: {
                            ...prev.jobTitle,
                            [language.key]: e.target.value,
                          },
                        }))
                      }
                    />
                  </Col>
                ))}
              </Row>

              <Row className="mt-3">
                <Col md="6" className="mb-2">
                  <label className="form-label">Vacancy type</label>
                  <RSelect
                    options={typeOptions}
                    value={
                      typeOptions.find(
                        (option) => option.value === form.vacancyType
                      ) ?? null
                    }
                    onChange={(option) =>
                      setForm((prev) => ({
                        ...prev,
                        vacancyType: option?.value ?? "",
                      }))
                    }
                    placeholder="Select vacancy type"
                  />
                </Col>
                <Col md="6" className="mb-2">
                  <label className="form-label">Display order</label>
                  <input
                    type="number"
                    className="form-control"
                    value={form.orderIndex}
                    onChange={(e) =>
                      setForm((prev) => ({
                        ...prev,
                        orderIndex: e.target.value,
                      }))
                    }
                  />
                </Col>
              </Row>
            </div>
          ) : (
            <div className="profile-ud-list">
              <div className="profile-ud-item">
                {LANGUAGES.map((language) => (
                  <div className="profile-ud wider" key={language.key}>
                    <span className="profile-ud-label">
                      Job title ({language.short})
                    </span>
                    <span className="profile-ud-value">
                      {vacancy?.jobTitle?.[language.key] || "-"}
                    </span>
                  </div>
                ))}
              </div>
              <div className="profile-ud-item">
                <div className="profile-ud wider">
                  <span className="profile-ud-label">Vacancy type</span>
                  <span className="profile-ud-value">
                    {VACANCY_TYPES_READABLE[vacancy?.vacancyType] ??
                      vacancy?.vacancyType ??
                      "-"}
                  </span>
                </div>
                <div className="profile-ud wider">
                  <span className="profile-ud-label">Display order</span>
                  <span className="profile-ud-value">
                    {vacancy?.orderIndex ?? "-"}
                  </span>
                </div>
                <div className="profile-ud wider">
                  <span className="profile-ud-label">Active</span>
                  <span className="profile-ud-value">
                    {vacancy?.isActive === true ? (
                      <span className="badge badge-dim badge-success">Active</span>
                    ) : vacancy?.isActive === false ? (
                      <span className="badge badge-dim badge-gray">Inactive</span>
                    ) : (
                      <span className="badge badge-dim badge-light">Not set</span>
                    )}
                  </span>
                </div>
              </div>
            </div>
          )}
        </form>
      </Block>
    </Card>
  );
};

export default VacancyBasicInfoBlock;
